import React, { useContext, useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Table,
  Button,
  Badge,
  Modal,
  Card,
  Form,
} from "react-bootstrap";
import "../../../assets/css/admin/payoutrequest/payoutrequestInAdmin.css";
import AdminMasterLayout from "../../../layout/admin/AdminMasterLayout";
import axios from "axios";
import AppContext from "../../../context/AppContext";
import Swal from "sweetalert2";

const PayoutRequestInAdmin = () => {
  const { baseUrl } = useContext(AppContext);
  const [payouts, setPayouts] = useState([]);
  const [transactionReference, setTransactionReference] = useState("");
  const [receiptFile, setReceiptFile] = useState(null);
  const [receipt, setReceipt] = useState(null);
  const [idToUpdateDeletePayout, setIdToUpdateDeletePayout] = useState("");
  const [addPayoutLoading, setAddPayoutLoading] = useState(false);
  const [loadingWithdrawId, setLoadingWithdrawId] = useState(null);
  const [showView, setShowView] = useState(false);
  const [showWithdraw, setShowWithdraw] = useState(false);
  const [selected, setSelected] = useState(null);
  const openView = (item) => {
    setSelected(item);
    setShowView(true);
  };

  const openWithdraw = (item) => {
    setSelected(item);
    setIdToUpdateDeletePayout(item.id);
    setShowWithdraw(true);
  };

  
  const viewAllUploadedpayout = () => {
    axios
      .get(`${baseUrl}/admin/payoutrequest/viewAllUploadedPayoutrequest`)
      .then((response) => {
        console.log(response.data);
        setPayouts(response.data.payouts || []);
      })
      .catch((error) => {
        console.log(error.response?.data);
        setPayouts([]);
      });
  };
  const markAsPaid = () => {
  setAddPayoutLoading(true);

  const formData = new FormData();

  formData.append("id", idToUpdateDeletePayout);

  // Approved ya Rejected jo bhi button se bhejna ho
  formData.append("status", "approved");

  // Agar receipt optional hai
  if (receiptFile) {
    formData.append("image", receiptFile);
  }

  // Agar transaction reference use karna hai
  if (transactionReference) {
    formData.append("transaction_reference", transactionReference);
  }

  axios
    .post(`${baseUrl}/admin/payoutrequest/updateStatus`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      Swal.fire({
        icon: "success",
        title: "Success",
        text: response.data.message,
      });

      viewAllUploadedpayout();
      resetForm();
      setShowWithdraw(false);
      setAddPayoutLoading(false);
    })
    .catch((error) => {
      console.log(error.response?.data);

      setAddPayoutLoading(false);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "Something went wrong",
      });
    });
};
const updateStatus = (id, status) => {
  setIdToUpdateDeletePayout(id);

  const formData = new FormData();
  formData.append("id", id);
  formData.append("status", status);

  axios
    .post(`${baseUrl}/admin/payoutrequest/updateStatus`, formData)
    .then((res) => {
      Swal.fire("Success", res.data.message, "success");
      viewAllUploadedpayout();
    })
    .catch((err) => {
      console.log(err.response?.data);
    });
};
  const resetForm = () => {
    setTransactionReference("");

    setReceipt(null);

    setSelected(null);

    setIdToUpdateDeletePayout("");

    setAddPayoutLoading(false);
  };
  useEffect(() => {
    viewAllUploadedpayout();
  }, []);

  return (
    <AdminMasterLayout>
      <Container fluid className="payout-container">
        {/* Header */}
        <Row className="mb-3">
          <Col>
            <h4>Payout Requests</h4>
            <p className="sub-text">
              Review and process seller withdrawal requests
            </p>
          </Col>
        </Row>

        {/* Table */}
        <Card>
          <Card.Body>
            <div className="table-responsive">
              <Table hover>
                <thead>
                  <tr>
                    <th>Request ID</th>
                    <th>Shop ID</th>
                    <th>Shop Name</th>
                    <th>Amount</th>
                    <th>Method</th>
                    <th className="d-none d-md-table-cell">Account Title</th>
                    <th className="d-none d-lg-table-cell">Account Number</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {payouts?.map((p, i) => (
                    <tr key={i}>
                      <td>{p.id}</td>

                      <td>{p.tpshop?.id}</td>

                      <td>
                        <div className="fw-semibold">
  {p.tpshop?.businessName}
</div>

<small className="text-muted">
  ID: {p.tpshop?.id}
</small>
                      </td>
                      <td className="fw-bold">{p.amount}</td>
                      <td>
                        <Badge bg="light" text="dark" className="method-badge">
                          {p.bankOrWallet}
                        </Badge>
                      </td>
                      <td className="d-none d-md-table-cell">
                       {p.accountHolderName}
                      </td>
                      <td className="d-none d-lg-table-cell">
                        {p.accountNumber}
                      </td>
                      <td>
                        <Badge
                          bg={p.status === "Pending" ? "warning" : "success"}
                        >
                          {p.status}
                        </Badge>
                      </td>
                      <td>
                        <div className="action-buttons">
                          <Button
                            size="sm"
                            variant="outline-secondary"
                            onClick={() => openView(p)}
                          >
                            View
                          </Button>

                       {p.status === "pending" && (
  <>
   <Button
  size="sm"
  variant="success"
  onClick={() => updateStatus(p.id, "approved")}
>
  Approve
</Button>

<Button
  size="sm"
  variant="danger"
  className="ms-2"
  onClick={() => updateStatus(p.id, "rejected")}
>
  Reject
</Button>
  </>
)}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </Card.Body>
        </Card>

        {/* VIEW MODAL */}
        <Modal show={showView} onHide={() => setShowView(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>{selected?.id} - Payout Detail</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {selected && (
              <div className="detail-grid">
                <div>Shop</div>
                <div>{selected.tpshop_id}</div>

                <div>Seller</div>
                <div>{selected.tpshop?.businessName}</div>

                <div>Amount</div>
                <div className="fw-bold">{selected.amount}</div>

                <div>Method</div>
                <div>
                  <Badge bg="light" text="dark">
                    {selected.bankOrWallet}
                  </Badge>
                </div>

                <div>Account Title</div>
               <div>{selected.accountHolderName}</div>

                <div>Account Number</div>
                <div>{selected.accountNumber}</div>

                <div>Requested</div>
                <div> {new Date(selected.created_at).toLocaleDateString("en-GB")}</div>

                <div>Status</div>
                <div>
                  <Badge bg="primary">{selected.status}</Badge>
                </div>
              </div>
            )}
          </Modal.Body>
        </Modal>

        {/* WITHDRAW MODAL */}
        <Modal
          show={showWithdraw}
          onHide={() => setShowWithdraw(false)}
          centered
          size="md"
        >
          <Modal.Header closeButton>
            <Modal.Title>Process Withdraw</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {selected && (
              <div className="p-2">
                {/* Info Box */}
                <div className="bg-light rounded p-3 mb-3">
                  <p className="mb-1">
                    <strong>Pay:</strong> {selected.tpshop?.businessName}
                  </p>
                  <p className="mb-1">
                    <strong>Method:</strong> {selected.bankOrWallet}
                  </p>
                  <p className="mb-1">
                    <strong>Account #:</strong> {selected.accountNumber}
                  </p>
                  <p className="mb-0">
                    <strong>Amount:</strong>{" "}
                    <span className="fw-bold text-dark">{selected.amount}</span>
                  </p>
                </div>

                {/* Transaction Reference */}
                {/* <Form.Group className="mb-3">
                  <Form.Label>Transaction Reference</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="e.g. TXN-123456"
                    className="py-2"
                  />
                </Form.Group> */}

                {/* Upload Receipt */}
                <Form.Group className="mb-3">
                  <Form.Label>Upload Receipt</Form.Label>

                  <label
                    className="border rounded d-flex flex-column align-items-center justify-content-center text-muted"
                    style={{
                      height: "120px",
                      cursor: "pointer",
                      borderStyle: "dashed",
                    }}
                  >
                    <i
                      className="bi bi-upload mb-2"
                      style={{
                        fontSize: "20px",
                      }}
                    ></i>

                    <small>
                      {receiptFile
                        ? receiptFile.name
                        : "Click to upload receipt (PDF/Image)"}
                    </small>

                    <Form.Control
                      type="file"
                      accept=".jpg,.jpeg,.png,.pdf"
                      hidden
                      onChange={(e) => setReceiptFile(e.target.files[0])}
                    />
                  </label>
                </Form.Group>

                {/* Action Button */}
                <div className="d-grid">
                  <Button
                    className="py-2 fw-semibold"
                    style={{
                      backgroundColor: "#22c55e",
                      border: "none",
                    }}
                    onClick={markAsPaid}
                    disabled={addPayoutLoading}
                  >
                    {addPayoutLoading ? "Loading..." : "✓ Mark as Paid"}
                  </Button>
                </div>
              </div>
            )}
          </Modal.Body>
        </Modal>
      </Container>
    </AdminMasterLayout>
  );
};

export default PayoutRequestInAdmin;
